export default {
  name: 'CollarShader',
  uniforms: {
    uColor: {
      value: [],
    },
    uRadius: {
      value: 3,
    },
    uLightPositions: { value: [] },
    uLightIntensities: { value: [0.6, 0.6] },
    uAmbientIntensity: { value: 0.6 },
  },
  vertexShader: /* glsl */ `
    #include <common>
    #include <logdepthbuf_pars_vertex>
    uniform vec3 uColor;
    uniform float uRadius;
    attribute vec3 origin;
    varying vec2 vUv;
    varying vec3 vColor;
    varying vec3 vNormal;

    void main() {
      vUv = uv;
      vNormal = normalMatrix * normal;
      vColor = uColor;

      vec3 radialVector = position - origin;
      vec3 radiusAdjustedPosition = position + radialVector * (uRadius - 1.0); // assume geometries created with radius of 1.0

      gl_Position = projectionMatrix * modelViewMatrix * vec4(radiusAdjustedPosition, 1.0 );
      #include <logdepthbuf_vertex>
    }`,
  fragmentShader: /* glsl */ `
    #include <common>
    #include <logdepthbuf_pars_fragment>
    uniform vec3 uLightPositions[2];
    uniform float uLightIntensities[2];
    uniform float uAmbientIntensity;
    varying vec2 vUv;
    varying vec3 vColor;
    varying vec3 vNormal;

    void main() {
      #include <logdepthbuf_fragment>

      vec3 baseColor = vColor;
      vec3 color = vec3(0.0);
      for (int i = 0; i < 2; i++) {
        float lightIntensity = max(dot(normalize(vNormal), normalize(uLightPositions[i])), 0.0);
        color += baseColor * lightIntensity * uLightIntensities[i];
      }

      float ambientLightIntensity = 0.6;
      color += baseColor * uAmbientIntensity;
      
      gl_FragColor = vec4(color, 1.0);
    }`,
}
